import { createFileRoute } from "@tanstack/react-router";

import { MaskRedirect } from "@/features/shared/route-masking";

export const Route = createFileRoute("/office/vendors/create")({
  component: () => (
    <MaskRedirect
      to="/office/vendors/"
      action="create-vendor"
      mask="/office/vendors/create"
    />
  ),
});
